import type { NextPage } from 'next';
import { Box } from '../../components/box';
import { GreenHouseBoard } from '../../components/greenhouse';
import { Section } from '../../components/layout/section';
import { Text } from '../../components/text';
import type { PageFragment } from '../../graphql/fragments/PageFragment.graphql';
import { fetchContentfulPage } from '../../lib/static/fetchStaticPage';
import { DEFAULT_PAGE_TTL } from '../../lib/static/static-page';
import { PAGE_OPTIONS } from '../../lib/utils/page';
import { TEXT } from '../../lib/utils/text';
import { PageTemplate } from '../../page-templates/generic-page';
import { fetchDepartments } from '../../server/helpers/greenhouse';
import type { GreenHouseDepartment } from '../../server/helpers/greenhouse';
const Careers: NextPage<Props> = ({
  page,
  departments
}) => <>
        <PageTemplate {...PAGE_OPTIONS.CAREERS} pageData={page} data-sentry-element="PageTemplate" data-sentry-source-file="index.tsx" />

        <Section anchor='open-roles' data-sentry-element="Section" data-sentry-source-file="index.tsx">
            <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
                <Text tag='h2' typeStyle='heading-lg' data-sentry-element="Text" data-sentry-source-file="index.tsx">
                    {TEXT.openRoles}
                </Text>
                <GreenHouseBoard departments={departments} data-sentry-element="GreenHouseBoard" data-sentry-source-file="index.tsx" />
            </Box>
        </Section>
    </>;
interface Props {
  departments: GreenHouseDepartment[];
  page: PageFragment;
}
export const getStaticProps = async () => {
  const [departments, page] = await Promise.all([fetchDepartments(), fetchContentfulPage(PAGE_OPTIONS.CAREERS.slug)]);
  return {
    props: {
      page,
      departments
    },
    revalidate: DEFAULT_PAGE_TTL
  };
};
export default Careers;